import EventWrapper from '../utils/EventWrapper';

export default class LineButton {
	constructor(scene, spriteNormal, spriteHover, number) {
		this.spriteNormal = spriteNormal; // normal texture name
		this.spriteHover = spriteHover; // hover texture name
		this.scene = scene;
		this.number = number;
		this.pressed = false;
	}

	create(offsetX, offsetY, originX, originY) {
		this.offsetX = offsetX;
		this.offsetY = offsetY;
		this.originX = originX;
		this.originY = originY;

		this.posX = this.scene.centerX + this.offsetX;
		this.posY = this.scene.centerY + this.offsetY;

		this.button = this.scene.add.sprite(this.posX, this.posY, this.spriteNormal).setOrigin(originX, originY);
		this.button.on('pointerdown', this.pointerDown, this);
		this.button.on('pointerup', this.pointerUp, this);
		this.button.on('pointerover', this.pointerOver, this);
		this.button.on('pointerout', this.pointerOut, this);
		this.button.setInteractive();
		this.interactable = true;
		this.pointerDownEvents = [];
		this.lineText = this.scene.add.bitmapText(this.posX, this.posY - 2, 'gameFont', this.number, 30, 1).setOrigin(0.5);
		this.lineText.tint = 0x000000;
	}

	pointerUp() {
		if (!this.interactable) return;
		this.setStateTexture();
	}

	pointerDown() {
		if (!this.interactable) return;
		this.pointerDownEvents.forEach(eW => {
			if (eW != null && eW.action != null) eW.action.call(eW.context);
		});
	}

	pointerOver() {
		if (!this.interactable) return;
	}

	pointerOut() {
		if (!this.interactable) return;
	}

	setInteractable(interactable) {
		this.interactable = interactable;
	}

	setStateTexture() {
		this.button.setTexture(this.pressed ? this.spriteHover : this.spriteNormal);
	}

	setState(pressed) {
		this.pressed = pressed;
		this.setStateTexture();
	}

	addPointerDownEvent(action, context) {
		if (action != null) this.pointerDownEvents.push(new EventWrapper(action, context));
	}
}
